import React from 'react';

const TimeCircle = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Time Circle">
        <path
          id="Stroke 1"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7082 9.00039C16.7082 13.2579 13.2573 16.7087 8.99984 16.7087C4.74234 16.7087 1.2915 13.2579 1.2915 9.00039C1.2915 4.74289 4.74234 1.29205 8.99984 1.29205C13.2573 1.29205 16.7082 4.74289 16.7082 9.00039Z"
          stroke="#1A1E27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Stroke 3"
          d="M11.8594 11.4524L8.71777 9.57823V5.53906"
          stroke="#1A1E27"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default TimeCircle;
